import { CarbonProgram } from "models";

export type ProgramFeature = "fields" | "footprinting" | "payout" | "cropMixComposer";

/**
 * Programs without platform features predate the per-feature settings and allow everything except footprinting,
 * which a program has to enable; payout needs a program.
 */
export const programAllows = (carbonProgram: CarbonProgram | null | undefined, feature: ProgramFeature): boolean => {
  const platformFeatures = carbonProgram?.platformFeatures;

  switch (feature) {
    case "footprinting":
      return !!platformFeatures?.footprinting?.enabled;
    case "fields":
      return !platformFeatures || !!platformFeatures.fieldManagement?.enabled;
    case "payout":
      return !!carbonProgram && (!platformFeatures || !!platformFeatures.fieldManagement?.wallet);
    case "cropMixComposer":
      return !platformFeatures || !!platformFeatures.planning?.cropMixComposer;
    default: {
      const unknownFeature: never = feature;
      return unknownFeature;
    }
  }
};
